import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Italic = (props) => (
  <Icon viewBox="0 0 30 30" {...props}>
    <g>
      <path d="M19 11V9h-7v2h2.7l-1.6 10H11v2h7v-2h-2.9l1.6-10z" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Italic;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Italic.js